import { updateMapGeoDataPosition } from '../../redux/action/map'
import { logger } from '../../logger/logger'

export const processGeoDataMessageThunk = (message) => (dispatch) => {
	switch (message?.type) {
		case 'geodata.DRIVER_GEO_UPDATED_EVENT':
			dispatch(updateMapGeoDataPosition(message.data))
			break
		default:
			logger.error('Unknown geodata message type: ', JSON.stringify(message))
			break
	}
}
